import {fork} from 'redux-saga/effects';
//import newsSaga from './news.sagas';
import settingsSaga from './settings.sagas';
import influencerSaga from './influencer.sagas';
import dashboardSaga from './dashboard.sagas';
import eulaSaga from './eula.sagas';
import userSaga from './user.sagas';
import overviewSaga from './overview.sagas';
import payoutSaga from './payout.sagas';
import taxSaga from './tax.sagas';

export default function*() {
    //yield fork(newsSaga);
    yield fork(settingsSaga);
    yield fork(influencerSaga);
    yield fork(dashboardSaga);
    yield fork(eulaSaga);
    yield fork(userSaga);
    yield fork(overviewSaga);
    yield fork(payoutSaga);
    yield fork(taxSaga);
}
